<div [ngClass]="isPreview ? 'h-full' : 'h-screen'" class="flex flex-col">
  <div
    [ngClass]="{
      'is-preview flex flex-col justify-center': isPreview,
      'pb-10': isPreview && !merchantNo
    }"
    class="wrapper relative">
    <div
      [ngClass]="isPreview ? 'mt-[30px] mb-2.5 text-2xl' : 'text-[52px] mt-20 mb-[26px]'"
      class="text-blue-900 text-center font-medium">
      Scan here to pay
    </div>
    <div class="text-[32px] font-bold text-center mb-36" *ngIf="!merchantNo && !ussdCode">
      {{ businessName }}
    </div>

    <div [ngClass]="isPreview ? 'w-[150px] h-[150px]' : 'w-[270px] h-[270px]'" class="mx-auto">
      <img [src]="qrCode" alt="QR code for collection link" class="w-full h-full object-cover" />
    </div>

    <ng-container *ngIf="merchantNo">
      <div
        [ngClass]="isPreview ? 'text-2xl' : 'text-[34px] leading-[38px]'"
        class="text-blue-900 mb-3 text-center mt-8 font-medium">
        or
      </div>
      <div [ngClass]="isPreview ? 'text-2xl' : 'text-[40px]'" class="text-blue-900 text-center font-medium">
        Dial {{ ussdCode }} to pay
      </div>

      <div [ngClass]="isPreview ? 'text-xl' : 'text-2xl '" class="font-medium text-center mt-3 text-blue-900">
        {{ businessName }}
      </div>

      <div [ngClass]="isPreview ? 'text-base' : 'text-2xl'" class="font-medium text-center my-2 pb-3 text-blue-900">
        Merchant No.
      </div>

      <div [ngClass]="isPreview ? 'gap-x-1 mb-[30px]' : 'gap-x-2 mb-[40px]'" class="justify-center flex text-blue-900">
        <div
          [ngClass]="isPreview ? 'w-[26px] h-[48px] p-1.5' : 'w-12 h-20 p-2 gap-2'"
          class="rounded-md border border-black flex-col justify-center items-center inline-flex"
          *ngFor="let n of merchantNo">
          <div [ngClass]="isPreview ? 'text-2xl' : 'text-5xl'" class="text-center text-black font-bold">{{ n }}</div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="relative">
    <div
      class="w-full bottom-0 h-[21vh] absolute"
      style="background: linear-gradient(0deg, rgba(2, 101, 156, 0.08) 1.79%, rgba(60, 105, 130, 0) 90.44%)"></div>
  </div>

  <div
    [ngClass]="isPreview ? 'px-5 py-3' : 'px-8 pt-11 pb-9'"
    class="bg-[#2F3235] flex justify-between items-center w-full">
    <div>
      <div [ngClass]="isPreview ? 'leading-3 text-sm' : 'text-lg leading-6 w-[288px]'" class="text-white font-medium">
        Better business payments
      </div>
      <div [ngClass]="isPreview ? 'leading-3 text-xs' : 'text-sm leading-4'" class="mt-3 text-white">
        <div>Learn more on onafriq.com</div>
        <div class="text-xs mt-2">Terms and Conditions apply.</div>
      </div>
    </div>
    <div>
      <img
        src="assets/images/logo/ona-logo-qr.png"
        alt="logo"
        [width]="isPreview ? 80 : 155"
        [height]="isPreview ? 23 : 55" />
    </div>
  </div>
</div>
